import React from 'react';
import { createBrowserRouter, Outlet, ScrollRestoration, useParams } from 'react-router-dom';
import IsLoggedInSubscriber from '../api/IsLoggedInSubscriber';
import Header from '../layout/Header';
import PreFooter from '../layout/PreFooter';
import Footer from '../layout/Footer';
import SiteLoader from '../components/SiteLoader';

// Workaround so we can keep our old Component structure
// React route v6 requires a "Component" prop
const lazyRoute = (loader) => async () => {
  const { default: Component } = await loader();
  return { Component };
};

const RootLayout = () => (
  <>
    <ScrollRestoration />
    <IsLoggedInSubscriber>
      <Header />
    </IsLoggedInSubscriber>

    {/* Route component comes in here */}
    <Outlet />

    <PreFooter />
    <Footer />
  </>
);

const SiteLoaderWrapper = () => {
  const params = useParams();

  return (
    <SiteLoader
      key={params.name}
      params={params}
    />
  );
};

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/', lazy: lazyRoute(() => import('../pages/Homepage')) },
      { path: '/registrieren', lazy: lazyRoute(() => import('../pages/Register')) },
      { path: '/registrieren/:idName', lazy: lazyRoute(() => import('../pages/Register')) },
      { path: '/aktivieren', lazy: lazyRoute(() => import('../pages/Activate')) },
      { path: '/team-beitreten', lazy: lazyRoute(() => import('../pages/JoinTeam')) },
      { path: '/login', lazy: lazyRoute(() => import('../pages/Login')) },
      { path: '/login/passwort-vergessen', lazy: lazyRoute(() => import('../pages/PasswortVergessen')) },
      { path: '/logout', lazy: lazyRoute(() => import('../pages/Logout')) },
      { path: '/die-aktion', lazy: lazyRoute(() => import('../pages/Aktion')) },
      { path: '/die-aktion/spielregeln', lazy: lazyRoute(() => import('../pages/Spielregeln')) },
      { path: '/richtig-aufladen/*', lazy: lazyRoute(() => import('../pages/RichtigAufladen')) },
      { path: '/trinktagebuch', lazy: lazyRoute(() => import('../pages/Trinktagebuch')) },
      { path: '/trinktagebuch/archiv', lazy: lazyRoute(() => import('../pages/DiaryArchive')) },
      { path: '/team', lazy: lazyRoute(() => import('../pages/TeamDiary')) },
      { path: '/team/archiv', lazy: lazyRoute(() => import('../pages/TeamDiaryArchive')) },
      { path: '/rankings', lazy: lazyRoute(() => import('../pages/Rankings')) },
      { path: '/daten-aendern', lazy: lazyRoute(() => import('../pages/Daten')) },
      { path: '/teilnahmebedingungen', lazy: lazyRoute(() => import('../pages/Teilnahmebedingungen')) },
      { path: '/kontakt-aufnehmen', lazy: lazyRoute(() => import('../pages/Kontakt')) },
      { path: '/:name/*', element: <SiteLoaderWrapper /> },
    ],
  },
]);

export default router;
